// extracted by mini-css-extract-plugin
export default {"modalHeader":"DeleteVerificationModal_modalHeader__eb-Yn"};